import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-quotes-slider' })
export class QuotesSliderComponent {
	private swiper: Swiper;

	constructor(public element: HTMLElement) {
		this.swiper = new Swiper(this.element, {
			speed: 600,
			navigation: {
				nextEl: this.element.querySelector('.swiper-button-next') as HTMLElement,
				prevEl: this.element.querySelector('.swiper-button-prev') as HTMLElement
			},
			keyboard: true,
			autoHeight: true,
			loop: true
		});
	}
}
